import React from 'react'
import PropTypes from 'prop-types'
import { Container, Grid, Typography } from 'gu-ui-kit'
import format from 'utils/dateFns/format'
import { parse } from 'date-fns'
import styles from 'modules/Tickets/Ticket/ticket.module.scss'
import clsx from 'clsx'
import AttachmentRow from 'modules/Tickets/Ticket/subcomponents/AttachmentRow'

const Message = ({ is_from_manager, created_at, text, attachments }) => {
  return (
    <div
      className={clsx(styles['message'], {
        [styles['message__from-support']]: is_from_manager,
      })}
    >
      <Grid direction={'column'} gap={16}>
        <Typography
          variant={'Body-15'}
          color={'Label-Fifth'}
          className={styles['message__text']}
          dangerouslySetInnerHTML={{ __html: text }}
        />

        {attachments.length > 0 && (
          <Grid gap={16} direction={'column'}>
            {attachments.map((file) => (
              <AttachmentRow
                className={styles['message__attachment-row']}
                {...file}
                key={'attachment-' + file.id}
              />
            ))}
          </Grid>
        )}

        <Container className={styles['message__header']}>
          <Typography variant={'Body-10'} color={'Label-Secondary'} noMargin>
            {created_at &&
              format(
                parse(created_at, "yyyy-MM-dd'T'HH:mm:ssXXX", new Date()),
                'HH:mm, d.MM.yyyy',
              )}
          </Typography>
        </Container>
      </Grid>
    </div>
  )
}

Message.propTypes = {
  id: PropTypes.number,
  user: PropTypes.string,
  is_from_manager: PropTypes.bool,
  text: PropTypes.string,
  created_at: PropTypes.string,
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      url: PropTypes.string,
      created_at: PropTypes.string, //"2023-06-08T08:33:42+03:00"
    }),
  ),
}

export default Message
